<template>

    <cms-view>

        <cms-heading title="Projecten" icon="entypo-archive">
            <cms-button color="positive" icon="magicon-plus" route="project-add" v-if="userIsAdmin">Toevoegen</cms-button>
            <cms-searchbar v-model="searchQuery"></cms-searchbar>
        </cms-heading>

        <cms-table-panel v-spinner="loading" :item-count="projects.totalCount || 0" :items-per-page="itemsPerPage" @page="offset = arguments[0]" :placeholder="!projects.items || !projects.items.length" clickable="true">
            <cms-table-header>
                <cms-th field="title" v-model="sort">Titel</cms-th>
                <cms-th field="code" v-model="sort">Projectcode</cms-th>
                <cms-th field="locationTitle" v-model="sort">Locatie</cms-th>
                <cms-th field="startDate" v-model="sort">Startdatum</cms-th>
                <cms-th field="endDate" v-model="sort">Einddatum</cms-th>
                <cms-th></cms-th>
            </cms-table-header>
            <tr v-for="project in projects.items" @click="showLoggers(project)">
                <td>{{ project.title }}</td>
                <td>{{ project.code }}</td>
                <td>{{ project.locationManual || project.locationTitle }}</td>
                <td>{{ project.startDate | date('LL') }}</td>
                <td>{{ project.endDate | date('LL') }}</td>
                <td class="actions" @click.stop>
                    <cms-link icon="entypo-eye" v-tooltip="'Loggers bekijken'" :to="{ name: 'loggers-project', params: { projectCode: project.code } }" />
                    <cms-link icon="magicon-edit" v-tooltip="'Wijzigen'" :to="{ name: 'project-edit', params: { id: project.id } }" v-if="userIsAdmin" />
                    <cms-link icon="magicon-trash" v-tooltip="'Verwijderen'" @click="deleteProject(project)" v-if="userIsAdmin" />
                </td>
            </tr>
        </cms-table-panel>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import ProjectQueries from 'app/queries/ProjectQueries'
    import ProjectMutations from 'app/mutations/ProjectMutations'

    import UserRole from 'app/enums/UserRole'

    @Component({

        name: 'projects',
        apollo: {

            projects: ProjectQueries.all({

                fetchPolicy: 'cache-and-network',
                variables(){

                    return {

                        offset: this.offset,
                        limit: this.itemsPerPage,
                        filter: null,
                        sortField: this.sort.field,
                        sortDirection: this.sort.direction,
                        search: this.searchQuery
                    }
                }
            })
        }
    })
    export default class Projects extends Vue
    {
        static SORT_STORAGE_KEY = "ProjectsSort";
        static SEARCH_STORAGE_KEY = "ProjectsSearch";

        data(){

            return {

                projects: {},
                loading: 0,

                offset: 0,
                itemsPerPage: 20,
                searchQuery: this.$storage.getSession(Projects.SEARCH_STORAGE_KEY, null),
                sort: this.$storage.getSession(Projects.SORT_STORAGE_KEY, {
                    field: 'code',
                    direction: 'ASC'
                })
            }
        }

        breadcrumb(){

            return 'Projecten';
        }

        created(){

            this.logger = this.$logger.child('Projects');

            this.$watch('sort', (sort) => this.$storage.setSession(Projects.SORT_STORAGE_KEY, sort));
            this.$watch('searchQuery', (searchQuery) => this.$storage.setSession(Projects.SEARCH_STORAGE_KEY, searchQuery || ''));

            // Reset paging when searching
            this.$watch('searchQuery', () => {
                this.offset = 0;
            });
        }

        showLoggers(project){

            this.$router.push({ name: 'loggers-project', params: { projectCode: project.code } });
        }

        deleteProject(project){

            this.$alert.confirmDelete('Weet je zeker dat je dit project wilt verwijderen?', true).then(({ result, modal }) => {

                if(!result){
                    return;
                }

                ProjectMutations.delete(project.id).then(() => {

                    this.logger.info(`Project ${project.id} deleted`);

                    this.$modal.close(modal);
                    this.$toast.success('Het project is verwijderd');

                    this.refetchQuery('projects');

                }).catch(e => {

                    this.logger.error(`Error deleting project ${project.id}`, e);

                    this.$modal.close(modal);
                    this.$toast.error('Het project kon niet worden verwijderd');
                });
            });
        }

        get userIsAdmin(){

            return [UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }
    }

</script>